import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-assign-error-modal-new',
  templateUrl: './tickets-assign-error-modal.component.html',
  styleUrls: ['./tickets-assign-error-modal.component.scss'],
  standalone: false,
})
export class TicketsAssignErrorModalComponent implements OnInit {
  public errorsList: any[];

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit() {}
}
